// Btn — botón del DS v2 con estilos inline (no depende de .landing-v2 wrapper)
//   variant: 'primary' (ink fill) | 'ghost' (border) | 'soft' (bg-bg2)
//   size:    'sm' | 'md' | 'lg'
//   as:      'button' (default) | otro elemento React (Link, 'a', etc.)

const PADDINGS = {
  sm: 'px-3 py-1.5 text-[12.5px]',
  md: 'px-5 py-3 text-[14px]',
  lg: 'px-7 py-3.5 text-[15px]',
}

const VARIANTS = {
  primary: 'bg-[var(--ink)] text-[var(--bg)] hover:-translate-y-px shadow-[0_1px_0_rgba(255,255,255,.08)_inset,0_6px_24px_rgba(11,11,15,.18)] hover:shadow-[0_1px_0_rgba(255,255,255,.08)_inset,0_12px_32px_rgba(11,11,15,.28)]',
  ghost:   'bg-transparent text-[var(--ink)] border border-[var(--line-2)] hover:bg-[rgba(11,11,15,.04)] hover:border-[var(--ink-3)]',
  soft:    'bg-[var(--bg-2)] text-[var(--ink-2)] hover:bg-[var(--bg-3)] border border-[var(--line)]',
}

export default function Btn({
  children,
  variant = 'primary',
  size = 'md',
  as: Tag = 'button',
  className = '',
  ...rest
}) {
  return (
    <Tag
      className={`inline-flex items-center justify-center gap-2 rounded-pill font-semibold transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand-1)] focus-visible:ring-offset-2 ${VARIANTS[variant]} ${PADDINGS[size]} ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  )
}
